const determineCtaText = (type) => {
  const textMap = {
    Event: 'Register now'
  }

  return textMap[type]
}

export default determineCtaText
